import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { selectContractors } from '../../payroll.selectors'
import { getContractorName, getContractorWageText } from '../../helpers'
import { ContractorPayrollHeader } from './ContractorPayrollHeader'
import { LastContractorPayments } from './LastContractorPayments'
import { Button, Checkbox, Icon, Separator, Table, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
export const ContPayrollSelectContractorTab = ({
  selectedUuid: initSelectedUuid,
  goForward,
}: {
  selectedUuid: string | undefined
  goForward: (_: string) => void
}) => {
  const navigate = useNavigate()
  const contractors = useReselector(selectContractors)
  const [selectedUuid, setSelectedUuid] = useState(initSelectedUuid)

  return (
    <div className="flex flex-col gap-4">
      <ContractorPayrollHeader currentTab={0} />
      <div className="w-full md:w-1/2">
        <LastContractorPayments />
      </div>
      <Separator />

      <Text variant={TypographyStyles.H3}>Select a contractor to pay</Text>

      <Text variant={TypographyStyles.BODY_SM}>
        When paying contractors, you will be asked to enter the number of hours
        worked.
      </Text>

      <div className="overflow-auto">
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="w-[40px]" />
              <Table.HeaderCell>
                <Text className="text-green-600">Contractor</Text>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {Object.values(contractors).length === 0 && (
              <Table.Row>
                <Table.Cell colSpan={2}>
                  <Text>No contractors found</Text>
                </Table.Cell>
              </Table.Row>
            )}
            {Object.values(contractors).map((contractor) => (
              <Table.Row
                key={contractor.uuid}
                onClick={() =>
                  selectedUuid === contractor.uuid
                    ? setSelectedUuid(undefined)
                    : setSelectedUuid(contractor.uuid)
                }
              >
                <Table.Cell className="w-[40px]">
                  <Checkbox checked={selectedUuid === contractor.uuid} />
                </Table.Cell>
                <Table.Cell>
                  <Text className="mb-1">
                    <b>{getContractorName(contractor)}</b>
                  </Text>
                  <Text>{getContractorWageText(contractor)}</Text>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center md:items-end gap-4">
        <div className="w-full md:w-1/4">
          <Button
            variant="secondary"
            onClick={() => navigate('/payroll/run_payroll')}
            className="w-full"
          >
            Cancel
          </Button>
        </div>
        <div className="hidden md:block md:w-1/2" />
        <div className="w-full md:w-1/4">
          <Button
            onClick={() => selectedUuid && goForward(selectedUuid)}
            className="w-full"
            disabled={!selectedUuid}
          >
            Continue <Icon icon={faArrowRight} />
          </Button>
        </div>
      </div>
    </div>
  )
}
